import { render, staticRenderFns } from "./purapprovalview.vue?vue&type=template&id=0c14d51d&scoped=true&"
import script from "./purapprovalview.vue?vue&type=script&lang=js&"
export * from "./purapprovalview.vue?vue&type=script&lang=js&"
import style0 from "./purapprovalview.vue?vue&type=style&index=0&id=0c14d51d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14d51d",
  null
  
)

export default component.exports